import { useState, useRef, useEffect } from 'react';
import leftArrowIcon from '@assets/icons/placement-page/left-arrow.svg';
import rightArrowIcon from '@assets/icons/placement-page/right-arrow.svg';
import Image from 'next/image';

const MonthSelector = ({
  onMonthChange,
  activeMonth,
  months,
  setActiveMonth,
  handleMonthClick,
  scroll,
  scrollContainerRef,
}) => {
  // const [activeMonth, setActiveMonth] = useState('January 2025');
  // const scrollContainerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);


  // const months = [
  //   'January 2025',
  //   'December 2024',
  //   'November 2024',
  //   'September 2024',
  //   'October 2024',
  //   'August 2024',
  // ];

  // const handleMonthClick = (month) => {
  //   setActiveMonth(month);
  //   if (onMonthChange) {
  //     onMonthChange(month);
  //   }
  // };

  // const scroll = (direction) => {
  //   if (scrollContainerRef.current) {
  //     // Make scroll distance responsive to container width
  //     const scrollDistance = Math.max(200, containerWidth / 3);

  //     scrollContainerRef.current.scrollBy({
  //       left: direction === 'left' ? -scrollDistance : scrollDistance,
  //       behavior: 'smooth',
  //     });
  //   }
  // };

  // Update container width on mount and resize
  useEffect(() => {
    const updateWidth = () => {
      if (scrollContainerRef.current) {
        setContainerWidth(scrollContainerRef.current.offsetWidth);
      }
    };

    // Initial width
    updateWidth();

    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  useEffect(() => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const activeButton = container.querySelector(
        `button:nth-child(${months.indexOf(activeMonth) + 1})`
      );

      if (activeButton) {
        // Calculate center position for the active button
        const containerCenter = container.offsetWidth / 2;
        const buttonLeft = activeButton.offsetLeft;
        const buttonWidth = activeButton.offsetWidth;
        const buttonCenter = buttonLeft + buttonWidth / 2;

        // Scroll to center the button
        container.scrollTo({
          left: buttonCenter - containerCenter,
          behavior: 'smooth',
        });
      }
    }
  }, [activeMonth]);

  return (
    <div className="relative mx-auto max-w-6xl overflow-hidden">
      {/* Left scroll button */}
      {/* Left fade gradient */}
      <div className="pointer-events-none absolute left-0 top-0 z-10 h-full w-10 bg-gradient-to-r from-white to-transparent" />

      {/* Right fade gradient */}
      <div className="pointer-events-none absolute right-0 top-0 z-10 h-full w-10 bg-gradient-to-l from-white to-transparent" />

      <button
        onClick={() => scroll('left')}
        className="absolute left-0 top-1/2 z-10 flex -translate-y-1/2 items-center justify-center"
        style={{
          width: '20px',
          height: '20px',
          flexShrink: 0,
          aspectRatio: '1/1',
        }}
        aria-label="Scroll left"
      >
        <Image src={leftArrowIcon} width={20} height={20} alt="Previous" />
      </button>

      {/* Month buttons scrollable container */}

      <div
        ref={scrollContainerRef}
        className="scrollbar-hide flex items-center gap-4 overflow-x-auto py-4 px-[60px] md:px-0
        "
        style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none',
          // Add padding on both sides to ensure content stays between the arrows
          paddingLeft: '60px',
          paddingRight: '60px',
          width: '100%',
        }}
      >
        {months?.map((month) => (
          <button
            key={month}
            onClick={() => handleMonthClick(month)}
            className={`
              min-w-max rounded-full py-2 px-[14px] font-proxima-nova text-[13px] capitalize transition-all md:px-6 md:py-2
              ${
                activeMonth === month
                  ? 'border-2 border-[#FFA5BA] bg-[#F00037] font-semibold text-white shadow-[0px_2px_20px_rgba(240,0,55,0.16)]'
                  : 'border border-black/5 bg-white font-normal text-[#1F1F1F] shadow-[0px_2px_16px_rgba(0,0,0,0.06)]'
              }
            `}
          >
            {month}
          </button>
        ))}
      </div>

      {/* Right scroll button */}
      <button
        onClick={() => scroll('right')}
        className="absolute right-0 top-1/2 z-10 flex -translate-y-1/2 items-center justify-center"
        style={{
          width: '20px',
          height: '20px',
          flexShrink: 0,
          aspectRatio: '1/1',
        }}
        aria-label="Scroll right"
      >
        <Image src={rightArrowIcon} width={20} height={20} alt="Next" />
      </button>
    </div>
  );
};

export default MonthSelector;
